<template>
    <div class="content" v-if="showShipList">
        <div class="v1">
            <div class="icon">
                <i class="el-icon-refresh refresh" :class="refreshing?'go':''" title="刷新" @click="refreshShipList()"></i>
                <img alt :src="require('@/assets/img/common/'+(showLayer?'open.svg':'hide.svg'))" width="26" :title="showLayer?'点击隐藏':'点击显示'" @click="clickShowLayer()"/>
            </div>
            <span class="title">船舶列表</span>
            <div class="p1">
                <img alt src="../../assets/img/common/close.png" @click="close"/>
            </div>
        </div>
        <div class="v2">
            <ul class="table-title" style="cursor: default">
                <li class="c1">序号</li>
                <li class="c2">名称</li>
                <!-- <li class="c3">MMSI</li> -->
                <li class="c4">设备状态</li>
            </ul>
            <ul v-for="(item, i) in dataList" :key="i" :style="{backgroundColor: currShipId==item.id?'#86e9f9':'', color: !item.isOnline?'gray':''}">
                <li class="c1">{{ i+1 }}</li>
                <li class="c2" :style="{fontWeight: !item.isOnline?'none':'bold'}" @click="handleClick(item.id, item.outletsId, 1)">{{ item.name }}</li>
                <!-- <li class="c3" @click="checkedShip(item.id, item.outletsId, 1)">{{ item.mmsi }}</li> -->
                <li class="c4">
                    <img alt :src="require('@/assets/img/ship/'+(item.isOnline?'antenna_on.svg':'antenna.svg'))" width="22" title="天线"/>
                    <img alt :src="require('@/assets/img/ship/'+(item.lasiOnline==1?'lsai_on.svg':'lsai.svg'))" v-if="item.lasiOnline!=undefined" width="20" title="落水AI设备"/>
                </li>
            </ul>
        </div>
        <div class="v3">
            <span>总数：{{total}}</span>
            <span>在线：{{onlineNum}}</span>
            <span>离线：{{offlineNum}}</span>
        </div>
    </div>
</template>

<script>

//引入自定义目标图层
import CustomTargetItem from '../../../public/hd/CustomTargetItem'
import { llPointToENPoint } from '@/utils'
import { isShipOffCourse } from '../../utils/sswgsz'

// 船舶列表
export default {
    inject: ['instanceProvide', 'app'],
    data() {
        return {
            show: true,
            dataList: [],
            currShipId: 0,

            targetList: [],
            lastSelectedTarget: null,

            ws: null,                       // 船舶信息 websocket对象
            warnWebsocket: null,            // 摄像头告警 websocket对象


            // 海图自营船舶索引数据
            shipIdData: {},

            // 总数、在线、离线
            total: 0,
            onlineNum: 0,
            offlineNum: 0,

            // 上一次告警时间 秒
            lastWarnTime: 0,

            // 刷新按钮旋转
            refreshing: false,
            showLayer: true,

            clickTimeout: null, // 用于判断双击

            
        }
    },
    computed: {
        hasLogin(){
            return this.$store.state.hasLogin
        },
        showShipList(){
            return this.$store.state.showShipList
        }
    },
    watch: {
        hasLogin(newVal, oldVal){
            if(newVal){
                // 刷新设置信息
                this.app.querySettingInfo()

                this.queryShipList(1)
                this.connectWebSocket()         // 登录成功之后 创建连接
                this.createWarnWebSocket()      // 登录成功之后 创建告警websocket连接
            }else{
                this.dataList = []
                console.log('退出登录，开始断开websocket')
                this.checkAndCloseWebSocket()   // 退出登录之后 关闭连接
            }
        }
    },
    mounted(){
        console.log('mounted>>>>船舶组件 登录状态='+this.hasLogin)
        // F5刷新场景
        if(this.hasLogin){
            // 刷新设置信息
            this.app.querySettingInfo()
            // 刷新标注告警信息
            this.app.queryShipWarnCategoryList()
            // 刷新航线偏航告警
            this.app.queryShipRouteWarnCategoryList()

            this.queryShipList(2)
            this.connectWebSocket()
            this.createWarnWebSocket()
            
        }
    },
    methods: {

        // 测试websocket信息
        // keleTest(){
        //     let info = {
        //         "callNum": "0",
        //         "deviceSeq": "400040001",
        //         "deviceType": "ANTENNA",
        //         "elevation": 0,
        //         "humidity": 0,
        //         "id": 252,
        //         "lat": 36.98193,
        //         "lot": 125.97308,
        //         "messageType": "LOCATION",
        //         "mmsi": 0,
        //         "outletsId": "ff8080817ba105a4017ba56d06730003",
        //         "reportTime": "2024-10-25 11:54:58",
        //         "shipName": "海蓝鲸轮",
        //         "shipStatus": 1,
        //         "voyageAngle": "104.78",
        //         "voyageSpeed": "19.17",
        //         "warnSwitch": 1
        //     }
        //     this.updateShipInfoByWebsocketMsg(JSON.stringify(info))
        // },

        

        /**
         * 检查并关闭websocket （切换账号、退出登录时调用）
         */
        checkAndCloseWebSocket(){
            if(this.ws){
                this.ws.close()
            }
            if(this.warnWebsocket){
                this.warnWebsocket.close()
            }
        },

        // 更新警告提示
        updateWarnMsgTips(info){
            console.log(info)
            let data = JSON.parse(info)
            if(data.warnType>=0){
                if(!this.checkWarnDuration){
                    console.log('在告警频率内，本次告警不提示')
                    return
                }
                // 如果勾选了文本告警
                if(this.app.userConf.textWarnShow==0){
                    this.app.updateShowWarnMsg(data.warnContent, 1)
                }
            }
        },

        // 检查告警频率
        checkWarnDuration(){
            let b = true
            let currWarnTime = Math.floor(new Date().getTime()/1000)
            if(this.app.userConf.warnDuration){
                if(currWarnTime-this.lastWarnTime<Math.abs(this.app.userConf.warnDuration)){
                    return false
                }else{
                    this.lastWarnTime = currWarnTime
                }
            }
            return b
        },

        // 创建告警websocket对象
        createWarnWebSocket(){
            if(this.warnWebsocket){
                this.warnWebsocket.close()
            }
            // 新建一个连接
            const wsUrl = this.webSocketUrl+"/dps/alarmMessagePush?username=" + localStorage.getItem('login_user_name') + "&Authorization=" + 'SSWGSZ-VMS' + localStorage.getItem('vms_token')
            this.warnWebsocket = new WebSocket(wsUrl)
            this.warnWebsocket.onopen = () => {
                console.log('warn websocket connected')
            }
            this.warnWebsocket.onmessage = (msg) => {
                if(msg.data != 'HEATBEAT_CONFIRM'){
                    this.updateWarnMsgTips(msg.data)
                }else{
                    // 测试
                    // let kk = {
                    //     warnType: 0,
                    //     warnContent: '我是测试告警内容'
                    // }
                    // this.updateWarnMsgTips(JSON.stringify(kk))
                }
            }
            this.warnWebsocket.onerror = (error) => {
                console.log('warn websocket 错误>>>>'+JSON.stringify(error))
            }
            // 保活
            let warnInterval = setInterval(()=>{
                if(this.warnWebsocket.readyState === WebSocket.OPEN){
                    this.warnWebsocket.send('HEATBEAT')
                }
            }, 30000)
            this.warnWebsocket.onclose = () => {
                console.log('warn websocket 关闭连接 ' +new Date())
                clearInterval(warnInterval)
            }
        },

        // 连接船舶位置websocket
        connectWebSocket() {
            if(this.ws){
                this.ws.close()
            }
            // 新建一个连接
            const wsUrl = this.webSocketUrl+"/dps/messagePush?username=" + localStorage.getItem('login_user_name') + "&Authorization=" + 'SSWGSZ-VMS' + localStorage.getItem('vms_token')
            this.ws = new WebSocket(wsUrl)

            this.ws.onopen = () => {
                console.log('websocket connected')
            }

            this.ws.onmessage = (msg) => {
                // console.log('websocket 收到消息>>>>'+new Date())
                // console.log(msg)
                if(msg.data != 'HEATBEAT_CONFIRM'){
                    this.updateShipInfoByWebsocketMsg(msg.data)
                }else{
                    
                }
            }

            this.ws.onerror = (error) => {
                console.log('websocket 错误>>>>'+JSON.stringify(error))
            }

            // 保活
            let shipInterval = setInterval(()=>{
                if(this.ws.readyState === WebSocket.OPEN){
                    this.ws.send('HEATBEAT')
                }
            }, 30000)

            this.ws.onclose = () => {
                console.log('websocket 关闭连接 '+new Date())
                clearInterval(shipInterval)
            }
        },

        // ==点线面告警模块===begin=====================================================================================================

        // 获取方向
        getfangx(p0, p1, p) {
            //判断点p在由p0,p1决定的直线左右侧
            var key = (p0.y - p1.y) * p.x + (p1.x - p0.x) * p.y + p0.x * p1.y - p1.x * p0.y;
            if (key > 0) {
                return "right";
            } else if (key == 0) {
                return "center";
            } else {
                return "left";
            }
        },

        //两个线段的交点
        segmentsIntr(a, b, c, d) {
            /** 1 解线性方程组, 求线段交点. **/
            // 如果分母为0 则平行或共线, 不相交  
            var denominator = (b.y - a.y) * (d.x - c.x) - (a.x - b.x) * (c.y - d.y);

            if (denominator == 0) {
                return false;
            } // 线段所在直线的交点坐标 (x , y)      

            var x = ((b.x - a.x) * (d.x - c.x) * (c.y - a.y) + (b.y - a.y) * (d.x - c.x) * a.x - (d.y - c.y) * (b.x - a.x) * c.x) / denominator;
            var y = -((b.y - a.y) * (d.y - c.y) * (c.x - a.x) + (b.x - a.x) * (d.y - c.y) * a.y - (d.x - c.x) * (b.y - a.y) * c.y) / denominator;
            /** 2 判断交点是否在两条线段上 **/
            // 交点在线段1上
            if ((x - a.x) * (x - b.x) <= 0 && (y - a.y) * (y - b.y) <= 0 // 且交点也在线段2上  
                && (x - c.x) * (x - d.x) <= 0 && (y - c.y) * (y - d.y) <= 0) {
                // 返回交点p  
                return { x: x, y: y };
            } //否则不相交  
            return false;
        },

        // 是否在面里面
        isInPolygon(checkPoint, polygonPoints) {
            var counter = 0;
            var i;
            var xinters;
            var p1, p2;
            var pointCount = polygonPoints.length;
            p1 = polygonPoints[0];
            for (i = 1; i <= pointCount; i++) {
                p2 = polygonPoints[i % pointCount];
                if (checkPoint[0] > Math.min(p1[0], p2[0]) && checkPoint[0] <= Math.max(p1[0], p2[0])) {
                    if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
                        if (p1[0] != p2[0]) {
                            xinters = (checkPoint[0] - p1[0]) * (p2[1] - p1[1]) / (p2[0] - p1[0]) + p1[1];
                            if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
                                counter++;
                            }
                        }
                    }
                }
                p1 = p2;
            }
            if (counter % 2 == 0) {
                return false;
            } else {
                return true;
            }
        },

        /**
         * 线面告警
         * @param shipCount     当前船舶最新位置信息
         * @param recordShip    船舶告警分类列表
         */
        gaoPointNearLine(shipCount, recordShip){
            // console.log(shipCount)
            // console.log(recordShip)
            if (recordShip.length>0) {
                var Indexed = recordShip.some(function(item) {return item.id == shipCount.id})
                if(!Indexed){
                    return false;
                }  
                for(var i = 0; i < recordShip.length; i++){
                    if (recordShip[i].id == shipCount.id) {
                        // 线告警处理
                        if (recordShip[i].ShippointXian.length > 0) {
                            for (var s = 0; s < recordShip[i].ShippointXian.length; s++) {
                                for (var j = 0; j < recordShip[i].ShippointXian[s].points.length; j++) {
                                    if (j < recordShip[i].ShippointXian[s].points.length - 1) {
                                        //取点
                                        var selScrnPo = {
                                            x: shipCount.lot * 10000000,
                                            y: shipCount.lat * 10000000
                                        };
                                        var startScrn = {
                                            x: recordShip[i].ShippointXian[s].points[j].lot * 10000000,
                                            y: recordShip[i].ShippointXian[s].points[j].lat * 10000000
                                        };
                                        var endScrn = {
                                            x: recordShip[i].ShippointXian[s].points[j + 1].lot * 10000000,
                                            y: recordShip[i].ShippointXian[s].points[j + 1].lat * 10000000
                                        };
                                        var direction = this.getfangx(startScrn, endScrn, selScrnPo); //判断点p在由p0,p1决定的直线左右侧

                                        var PointNear;
                                        if (recordShip[i].ShippointXian[s].pointVal[j] == undefined) {
                                            recordShip[i].ShippointXian[s].pointVal[j] = {
                                                "PointNear": selScrnPo,
                                                "direction": direction
                                            };
                                        } else {
                                            PointNear = this.segmentsIntr(selScrnPo, recordShip[i].ShippointXian[s].pointVal[j].PointNear, startScrn, endScrn);//两个线段的交点

                                            if (recordShip[i].ShippointXian[s].pointVal[j].direction != "center") {
                                                if (recordShip[i].ShippointXian[s].pointVal[j].direction != direction && PointNear != false) {
                                                    recordShip[i].ShippointXian[s].pointVal[j].PointNear = selScrnPo;
                                                    recordShip[i].ShippointXian[s].pointVal[j].direction = direction;
                                                    this.saveGaoPointMsg(shipCount, 2, 10, recordShip[i].ShippointXian[s].markName);
                                                } else {
                                                    recordShip[i].ShippointXian[s].pointVal[j].PointNear = selScrnPo;
                                                    recordShip[i].ShippointXian[s].pointVal[j].direction = direction;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }


                        // 面告警处理
                        if (recordShip[i].ShippointMian.length > 0) {
                            var selScrnPo = [shipCount.lot, shipCount.lat];
                            for (var s = 0; s < recordShip[i].ShippointMian.length; s++) {
                                var startScrnall = [];
                                for (var j = 0; j < recordShip[i].ShippointMian[s].points.length; j++) {
                                    startScrnall[j] = [recordShip[i].ShippointMian[s].points[j].lot, recordShip[i].ShippointMian[s].points[j].lat];
                                }
                                if (JSON.stringify(recordShip[i].ShippointMian[s].pointVal) == '{}') {
                                    //记录区域状态
                                    recordShip[i].ShippointMian[s].pointVal = {
                                        "id": recordShip[i].id,
                                        "markType":  "3",
                                        "pointstu": this.isInPolygon(selScrnPo, startScrnall),
                                        "LowSpeed": 0,
                                        "OverSpeed": 0
                                    };
                                }
                                if (this.isInPolygon(selScrnPo, startScrnall) == true) {//面内
                                    if (recordShip[i].ShippointMian[s].lowSpeedEnabled == true && recordShip[i].ShippointMian[s].pointVal.LowSpeed == 0 && parseInt(shipCount.voyageSpeed) < parseInt(recordShip[i].ShippointMian[s].limetedLowSpeed)) {
                                        //最低航速
                                        recordShip[i].ShippointMian[s].pointVal.LowSpeed = 1;
                                        recordShip[i].ShippointMian[s].pointVal.OverSpeed = 0;
                                        this.saveGaoPointMsg(shipCount, 3, 0, recordShip[i].ShippointMian[s].markName,parseInt(recordShip[i].ShippointMian[s].limetedLowSpeed),parseInt(shipCount.voyageSpeed));
                                    }
                            
                                    if (recordShip[i].ShippointMian[s].overSpeedEnabled == true && recordShip[i].ShippointMian[s].pointVal.OverSpeed == 0 && parseInt(shipCount.voyageSpeed) > parseInt(recordShip[i].ShippointMian[s].limetedOverSpeed)) {
                                        //最高航速
                                        recordShip[i].ShippointMian[s].pointVal.OverSpeed = 1;
                                        recordShip[i].ShippointMian[s].pointVal.LowSpeed = 0;
                                        this.saveGaoPointMsg(shipCount, 3, 1, recordShip[i].ShippointMian[s].markName,parseInt(recordShip[i].ShippointMian[s].limetedOverSpeed),parseInt(shipCount.voyageSpeed));
                                    }
                                }else{
                                    recordShip[i].ShippointMian[s].pointVal.OverSpeed = 0;
                                    recordShip[i].ShippointMian[s].pointVal.LowSpeed = 0;
                                }
                                //进行告警
                                if (recordShip[i].ShippointMian[s].pointVal.pointstu == true && this.isInPolygon(selScrnPo, startScrnall) == false && recordShip[i].ShippointMian[s].outOfAreaEnabled == true) {
                                    //驶出安全区域
                                    this.saveGaoPointMsg(shipCount, 3, 3, recordShip[i].ShippointMian[s].markName);
                                } else if (recordShip[i].ShippointMian[s].pointVal.pointstu == false && this.isInPolygon(selScrnPo, startScrnall) == true && recordShip[i].ShippointMian[s].enterAreaEnabled == true) {
                                    //进入危险区域
                                    this.saveGaoPointMsg(shipCount, 3, 2, recordShip[i].ShippointMian[s].markName);
                                }
                                recordShip[i].ShippointMian[s].pointVal.pointstu = this.isInPolygon(selScrnPo, startScrnall);
                            }
                        }


                    }
                }
            }
        },

        // 保存告警信息
        saveGaoPointMsg(shipCount, size, waType, name,limitedSpeed, currentSpeed) {
            var Parameters = {
                "agentId": localStorage.getItem('login_agent_id'),
                "outletsId": shipCount.outletsId,
                "warnContent": "",
                "warnTime": shipCount.reportTime,
                "warnType": ""
            };

            if (size == 2) {
                Parameters.warnType = 1;
                Parameters.warnContent = "船舶" + shipCount.shipName + "跨过【" + name + "】警戒线！";
            } else if (size == 3) {
                if (waType == 0) {
                    Parameters.warnType = 4;
                    Parameters.warnContent = "船舶" + shipCount.shipName + "在【"+name+"】区域航速过低！限速:"+limitedSpeed+"节，当前航速:"+currentSpeed+"节";
                } else if (waType == 1) {
                    Parameters.warnType = 5;
                    Parameters.warnContent = "船舶" + shipCount.shipName + "在【"+name+"】区域航速过高！限速:"+limitedSpeed+"节，当前航速:"+currentSpeed+"节";
                } else if (waType == 2) {
                    Parameters.warnType = 2;
                    Parameters.warnContent = "船舶" + shipCount.shipName + "进入【" + name + "】区域！";
                } else {
                    Parameters.warnType = 3;
                    Parameters.warnContent = "船舶" + shipCount.shipName + "驶出【" + name + "】区域！";
                }
            }

            // console.log("hahahhah哈哈哈哈哈哈哈哈哈"+new Date())
            // console.log(Parameters)

            // 保存一条告警信息 (前端触发的标注告警，不会再通过websocke发送到前端)
            this.sswgPost('/warn/saveWarn', Parameters, true, 'json').then(res => {
                // console.log(res)
            })

            let warnInfo = {
                warnType: Parameters.warnType,
                warnContent: Parameters.warnContent
            }
            // 弹出告警
            this.updateWarnMsgTips(JSON.stringify(warnInfo))
        },

        // 保存偏航告警
        getRouteDistance(shipCount,name){
            var Parameters = {
                "agentId": localStorage.getItem('login_agent_id'),
                "outletsId": shipCount.outletsId,
                "warnContent": "",
                "warnTime": shipCount.reportTime,
                "warnType": ""
            };
            Parameters.warnType = 6
            Parameters.warnContent = "船舶" + shipCount.shipName + "偏离" + name;
            // 保存一条告警信息 (前端触发的标注告警，不会再通过websocke发送到前端)
            this.sswgPost('/warn/saveWarn', Parameters, true, 'json').then(res => {
                // console.log(res)
            })

            let warnInfo = {
                warnType: Parameters.warnType,
                warnContent: Parameters.warnContent
            }
            // 弹出告警
            this.updateWarnMsgTips(JSON.stringify(warnInfo))
        },

        // ==点线面告警模块===end=======================================================================================================

        /**
         * 根据websocket数据更新船舶信息
         * @param info 船舶信息
         */
        updateShipInfoByWebsocketMsg(info){
            // 如果未初始化完成，则不处理 （场景：刷新页面的时候，会报错）
            if(!this.instanceProvide.itemLayer || this.instanceProvide.itemLayer.items().length==0){
                return
            }
            let data = JSON.parse(info)
            // 船舶索引
            const idIndex = this.app.shipIdData['shipId'+data.id]
            const center = llPointToENPoint(data.lot, data.lat)
            const cog = Number(data.voyageAngle)    // 航向
            const sog = Number(data.voyageSpeed)    // 航速
            let warnTips = '' // 告警提示

            // ==电子围栏检测==begin===================================================================================
            this.gaoPointNearLine(data, this.app.shipMarkWarnList) // 线面告警
            // this.routeWarningProcessing(data, this.app.shipRouteWarnList); //航线告警
            // 偏航告警
            // console.log(this.app.shipRouteWarnData[''+data.id])
            let b = isShipOffCourse([data.lot, data.lat], this.app.shipRouteWarnData[''+data.id])
            // console.log('是否偏航>> '+b)

            if(b){
                warnTips = '【偏航】'
            }
            // ==电子围栏检测==end===================================================================================
            
            const text = this.convertShipText(data.shipName, data.mmsi, data.callNum, data.voyageSpeed, warnTips)
            try{
                let labelFillColor = '#d4eaee'
                if(warnTips){
                    labelFillColor = '#ff784a' // #ff4308 #ff784a
                }
                this.instanceProvide.itemLayer.items()[idIndex].updateShipInfoByWebSocketData(center, text, cog, sog, labelFillColor)
            }catch(error){
                console.warn('方法未初始化')
            }
            // 如果是当前船舶，则也更新显示信息
            if(data.id==this.currShipId){
                this.app.updateShipInfoByWebsocketData(data.lot, data.lat, cog, sog, data.reportTime)
            }
        },

        close() {
            this.$store.commit('updateShowShipList', false)
        },

        /**
         * 刷新船舶列表
         */
        refreshShipList(){
            this.refreshing = true
            setTimeout(()=>{
                this.refreshing = false
            }, 1000)
            this.queryShipList(2)
            this.$message({ message: '已刷新', type: 'success', duration: 1500 })
        },

        /**
         * 点击显示 或 隐藏图层
         */
        clickShowLayer(){
            let b = !this.showLayer
            this.showLayer = b
            if(this.instanceProvide.itemLayer){ 
                this.instanceProvide.itemLayer.setVisible(b)
            }
        },

        /**
         * 查询船舶列表
         * @param src 来源 1:登录 2:F5刷新页面
         */
        queryShipList(src){
            console.log('查询船舶列表 '+src)
            this.sswgPost('/outlets/shiplist', {}).then(res => {
                console.log(res)
                this.total = res.data.total
                this.onlineNum = res.data.noOfOnline
                this.offlineNum = res.data.noOfOffline

                const seconds = Math.floor(new Date().getTime() / 1000)

                let shipList = res.data.shipList
                for(let i=0; i<shipList.length; i++){
                    // console.log(shipList[i].lsaiDeviceInfo)
                    // 如果落水设备信息字段存在
                    if(shipList[i].lsaiDeviceInfo){
                        let lsaiInfo = JSON.parse(shipList[i].lsaiDeviceInfo)
                        console.log(lsaiInfo)
                        if(seconds - lsaiInfo.ts < 370){   // 5分钟+10秒
                            shipList[i].lasiOnline = 1
                        }else{
                            shipList[i].lasiOnline = 0
                        }
                        console.log(shipList)
                    }
                }

                // 过滤字段
                this.dataList = shipList.map(({id, outletsId, name, mmsi, positionDeviceId, lat, lot, imo, speed, callNum, isOnline, lasiOnline}) => ({id, outletsId, name, mmsi, positionDeviceId, lat, lot, imo, speed, callNum, isOnline, lasiOnline}));

                console.log(this.dataList)

                this.app.shipList = this.dataList
            
                // 添加到海图上
                if(src==2){
                    setTimeout(() => {
                        this.drawTarget()
                    }, 3000)
                }else{
                    this.drawTarget()
                }
                
            }).catch(err => {
                console.log(err)
                // 网络出错，一般是后台token失效，故直接退出登录，引导用户重新登录
                this.$store.commit('logout')
            })
        },

        // 添加船舶到海图
        async drawTarget() {
            // 清除原来的物标，刷新页面时为null
            if(this.instanceProvide.itemLayer){ 
                this.instanceProvide.itemLayer.clearItems()
            }

            const userConf = this.app.userConf
            let foreShow = this.app.userConf.foreShow==1?true:false
            let speedToShow = this.app.userConf.speedToShow==1?true:false

            let shipIdIndex = 0 // 船舶索引
            for(let i=0; i<this.dataList.length; i++){
                let ship = this.dataList[i]
                if(ship.lot){
                    // console.log('我是第+'+i)
                    // console.log(ship)
                    // 记录船舶所在的索引
                    this.app.shipIdData['shipId'+ship.id] = shipIdIndex
                    shipIdIndex++
                    const point = new CustomTargetItem({
                        center: llPointToENPoint(ship.lot, ship.lat),
                        text: this.convertShipText(ship.name, ship.mmsi, ship.callNum, ship.speed),    // 船名+MMSI+呼号+速度 
                        shipScale: 10,                  //三角船显示层级
                        titleScale: 8,                  //船名显示层级
                        cog: 0,                         //航向
                        sog: 0,                         //航速
                        hdg: 0,                         //船艏向
                        fillType: 1,                    //船只填充类型
                        fillColor: '#2ECC71',           //船只填充颜色
                        strokeColor: '#000000',         //船只边框颜色
                        strokeType: 1,                  //船只边框类型
                        strokeWeight: 1,                //船只边框宽度
                        textColor: '000000',            //文本颜色
                        labelFillColor: '#d4eaee',      //Label填充颜色 #d4eaee
                        labelFillType: 1,               //Label填充类型
                        fontSize: 9,                   //文字大小
                    })

                    point.setShipIdAndMerchantId(ship.id, ship.outletsId, foreShow, speedToShow)   // 补充参数 船ID和店铺ID

                    point.setEnableMouseTracking(true)      // 使hover效果生效
                    this.instanceProvide.itemLayer.addItem(point)

                    point.on('doubleclick', (item, event) => {
                        console.log(item, event);
                    })

                    //pressed 鼠标按下
                    point.on('pressed', (item, event) => {
                        //编辑状态(启用之后，可以移动点)
                        // item.setState(SceneItemCommon.ItemState.editing)

                        //pressed 鼠标抬起
                        point.on('release', (item, event) => {
                            //结束编辑状态
                            // item.setState(SceneItemCommon.ItemState.normal)

                            // 如果有上一个，则清除上一个的选择状态
                            if (this.lastSelectedTarget) {
                                this.lastSelectedTarget.setSelected(false)
                            }
                            item.setSelected(true)
                            this.lastSelectedTarget = item
                            item.setOptions({
                                fillColor: '#ffff00',
                                fillType: 1,
                                strokeColor: '#ff0000'
                            })
                           
                        })
                        console.log(item)
                        // item.setZIndex(10000)
                        // 选中船舶
                        this.checkedShip(item.shipId, item.merchantId, 2)
                    })

                    point.on('hoverenter', (item, event) => {
                        // console.log(22222);
                        item.setOptions({
                            fillColor: '#ffff00',
                            fillType: 1,
                            strokeColor: '#ff0000'
                        })
                    })

                    point.on('hoverleave', (item, event) => {
                        item.setOptions({
                            fillColor: '#2ECC71',
                            fillType: 1,
                            strokeColor: '#000000'
                        })
                    })

                    this.targetList.push(point)
                }
            }
            this.instanceProvide.itemLayer.setZIndex(8000)
            // this.instanceProvide.itemLayer.update() // 更新
        }, 

        /**
         * 转换船舶提示文本     
         * @param name      船名    必填
         * @param mmsi      MMSI    
         * @param callNum   呼号
         * @param speed     航速
         * @param warnTips  告警提示 如：【偏航中】
         */
        convertShipText(name, mmsi, callNum, speed, warnTips){
            let text = name
            if(warnTips){
                text += warnTips
            }
            const userConf = this.app.userConf
            if(mmsi!=null && userConf.mmsiShow==1){
                text += '\n'+mmsi
            }
            if(callNum!=null && callNum!='0' && userConf.callNumShow==1){
                text += '\n'+callNum
            }
            if(speed!=null && userConf.speedShow==1){
                text += '\n'+speed+' Kn'
            }
            return text
        },

        // 查询船舶信息 outletsId:店铺ID
        queryShipDetail(id, outletsId, src, b){
            this.currShipId = id
            this.sswgPost('/outlets/fetchShipDetail2', {outletsId: outletsId}).then(res => {
                console.log(res)

                this.$emit('change', res.data, src, b)
                this.$store.commit('updateShowShipDetail', true)

            }).catch(err => {
                console.log(err)
                // 网络出错，一般是后台token失效，故直接退出登录，引导用户重新登录
                this.$store.commit('logout')
            })
        },

        /**
         * 点击选中某一艘船
         * @param id            船id
         * @param outletsId     店铺id
         * @param src           来源 1:点击船舶列表中的船舶 2:点击海图上面的船舶(不需要居中定位)
         * @param b             双否双击操作 0:否 1:是
         */
        checkedShip(id, outletsId, src, b){
            this.queryShipDetail(id, outletsId, src, b)
        },

        /**
         * 点击选中某一艘船
         */
        handleClick(id, outletsId, src) {
            // 如果定时器已存在，说明在间隔内发生了第二次点击，判定为双击
            if (this.clickTimeout) {
                clearTimeout(this.clickTimeout); // 清除定时器，取消尚未执行的单击
                this.clickTimeout = null;
                this.checkedShip(id, outletsId, src, 1)        // 执行双击操作
            } else {
                // 第一次点击，设置定时器，延迟后执行单击操作
                this.clickTimeout = setTimeout(() => {
                    this.checkedShip(id, outletsId, src)    // 执行单击操作
                    this.clickTimeout = null                // 执行完毕后清空定时器
                }, 300);                                    // 延迟时间可根据需要调整，通常为250-300毫秒
            }
        },
    }

}

</script>

<style lang="scss" scoped>
    .content {
        width: 230px;
        height: calc(100% - 118px);
        background-color: #1686d8;
        border: 1px solid #000;
        border-radius: 5px;
        // margin-left: 1px;

        .v1 {
            width: 230px;
            height: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-content: center;
            .icon {
                display: flex;
                align-items: center;
                .refresh {
                    font-size: 18px;
                    color: #85e984;
                    margin-left: 4px;
                    padding-right: 4px;
                    cursor: pointer;
                }
                .go {
                    transform-origin: 50% 50%;
                    transform: rotate(360deg);
                    transition: all 1s;
                }
                img:hover {
                    cursor: pointer;
                }
            }
            .title {
                color: #FFF;
                font-weight: bold;
                line-height: 30px;
                font-size: 15px;
            }
            .p1 {
                background-color: #1686d8;
                // background-color: #c7bb84;
                padding-right: 5px;
                padding-top: 5px;
                img {
                    cursor: pointer;
                }
            }
        }

        .v2 {
            background-color: #e5efff;
            // width: 100%;
            height: calc(100% - 60px);
            // height: 300px;
            overflow-y: auto;
            border-bottom: 1px solid #000000;
            ul {
                display: flex;
                text-align: center;
                line-height: 26px;
                font-size: 14px;
                color: #000;
                border-bottom: 1px dashed rgb(201, 199, 199);
                .c1 {
                    width: 40px;
                }
                .c2 {
                    width: 116px;
                }
                .c3 {
                    width: 90px;
                }
                .c4 {
                    width: 70px;
                    display: flex;
                    img {
                        padding-left: 3px;
                    }
                }

                .c2:hover {
                    cursor: pointer;
                }
            }
            ul:hover {
                background-color: #86e9f9;
                // cursor: pointer;
            }
            .table-title {
                background: url(../../assets/img/common/table_bg.png) left top / 100% 100% no-repeat #1832a8;
                color: #FFF;
                font-size: 12px;
                line-height: 16px;
                user-select: none;
            }
        }
        .v3 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            padding: 0 10px;
            color: #FFFFFF;
        }

        .online {
            height: 5px;
            height: 5px;
            background-color: #00FF00;
            border-radius: 50%;
            display: inline-block;
        }
    }
</style>